<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" clearable placeholder="名称/联系电话/联系地址" style="width: 200px; margin-right: 3px;"></Input>
      <DatePicker size="small" type="daterange" v-model="selectCreateDatetime" placeholder="选择日期"
                  style="margin-right: 3px; width: 200px;"></DatePicker>

      <Button type="primary" size="small" @click="onFilterClick">查询</Button>
      <Dropdown size="small" style="margin-right: 3px" @on-click="DropdownonFilterClick">
        <Button  size="small" type="primary">
<!--          查询-->
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="createDatetime">创建时间</DropdownItem>
          <DropdownItem name="setupDatetime">安装时间</DropdownItem>
          <DropdownItem name="receptDatetime">收款时间</DropdownItem>
        </DropdownMenu>
      </Dropdown>

    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="computeCol" :stripe="true" :data ="content" ref="table"
                 :height="tableHeight" :row-class-name="rowClassName"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)" @on-selection-change="onselectionchange"
                 @on-select="onselect" @on-select-cancel="onselectcancel" @on-select-all="onselectall" @on-select-all-cancel="onselectallcancel"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>


    <bind-positioning-devices-modal v-model="bindPositioningDevicesModal" :initValue="bindPositioningDevicesId"
                                    @on-success="onModifySuccess"></bind-positioning-devices-modal>
    <bind-positioning-devices-fittings-modal v-model="bindPositioningDevicesFittingsModal" :initValue="bindPositioningDevicesFittingsId"
                                             @on-success="onModifySuccess"></bind-positioning-devices-fittings-modal>
    <change-installer-modal v-model="changeInstallerModal" :initValue="changeInstallerId"
                            @on-success="onModifySuccess"></change-installer-modal>
    <confirm-recept-modal v-model="confirmReceptModal" :initValue="confirmReceptId"
                          @on-success="onModifySuccess"></confirm-recept-modal>
    <confirm-installed-modal v-model="confirmInstalledModal" :initValue="confirmInstalledId"
                             @on-success="onModifySuccess"></confirm-installed-modal>
    <temp-vehicle-picture-modal v-model="tempVehiclePictureModal" :initValue="tempVehiclePictureId"
                                @on-success="onModifySuccess"></temp-vehicle-picture-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <install-order-base-detail-modal v-model="installOrderBaseDetailModal" :initValue="installOrderBaseDetailId"
                                     @on-success="onModifySuccess"></install-order-base-detail-modal>
    <export-vehicle-cert-modal v-model="exportVehicleCertModal" :installed="exportVehicleCertInstalled"
                               :initValue="exportVehicleCertId"></export-vehicle-cert-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal" @on-column-update="onColumnUpdate"></web-table-columns-modal>
    <install-order-change-business-user-modal v-model="changeBusinessUserModal" :initValue="changeBusinessUserId" @on-success="onModifySuccess"></install-order-change-business-user-modal>
    <install-order-picture-modal v-model="installOrderPictureModal" :initValue="installOrderPictureModalId"></install-order-picture-modal>
    <vehicle-picture-modal v-model="vehiclePictureModal" :initValue="vehiclePictureId"></vehicle-picture-modal>
    <vehicle-identificationcode-modal v-model="vehicleIdentificationcodeModal" :installed="vehicleIdentificationcodeInstalled"
                                          :initValue="vehicleIdentificationcodeId" @on-success="onSuccess"></vehicle-identificationcode-modal>
<!--    <inquire-operation-modal v-model="inquireOperationModal" :initValue="inquireOperationId"></inquire-operation-modal>-->

  </div>
</template>

<script>
import InstallOrderDetailModal from '@/view/om/components/install-order-detail-modal'
import InstallOrderBaseDetailModal from '@/view/om/components/install-order-base-detail-modal'
import BindPositioningDevicesModal from '@/view/om/components/bind-positioning-devices-modal'
import ChangeInstallerModal from '@/view/om/components/change-installer-modal'
import ConfirmReceptModal from '@/view/om/components/confirm-recept-modal'
import ConfirmInstalledModal from '@/view/om/components/confirm-installed-modal'
import TempVehiclePictureModal from '@/view/om/components/temp-vehicle-picture-modal'
import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import ExportVehicleCertModal from '@/view/crm/components/export-vehicle-cert-modal'
import InstallOrderChangeBusinessUserModal from '@/view/om/components/install-order-change-business-user-modal'
import InstallOrderPictureModal from '@/view/om/components/install-order-picture-modal'
import BindPositioningDevicesFittingsModal from '@/view/om/components/bind-positioning-devices-fittings-modal'
import VehiclePictureModal from '@/view/crm/components/vehicle-picture-modal'
import VehicleIdentificationcodeModal from '@/view/crm/components/vehicle-identificationcode-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'
import axios from '@/libs/api.request'

export default {
  name: 'usergroupinstallorders',
  components: {
    InstallOrderDetailModal,
    BindPositioningDevicesModal,
    ChangeInstallerModal,
    ConfirmReceptModal,
    ConfirmInstalledModal,
    TempVehiclePictureModal,
    VehicleInfoDetailModal,
    InstallOrderBaseDetailModal,
    ExportVehicleCertModal,
    InstallOrderChangeBusinessUserModal,
    InstallOrderPictureModal,
    BindPositioningDevicesFittingsModal,
    VehiclePictureModal,
    VehicleIdentificationcodeModal
    // InquireOperationModal
  },
  data () {
    return {

      uploadExcel: false,
      // 导入模板地址
      EXCELSrc: '/ERP/om/uploadAddInstallorderFile.xlsx',

      installOrderList: [],

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      selectCreateDatetime: [],
      stateFilter: null,
      installedFilter: null,
      qghyptOptionFilter: null,
      uploadStateFilter: null,
      receptFilter: null,
      installerFilter: null,
      businessUserFilter: null,
      billTypeFilter: null,
      gdcdgovVehicleStateFilter: null,
      salesChannelFilter: null,
      businessTypeFilter: null,
      isfreeTypeFilter: null,
      FilterClickFilter: null,
      timeoutLogoFilter: null,

      installers: [],
      marketsales: [],

      // 指定业务跟进
      changeBusinessUserModal: false,
      changeBusinessUserId: null,

      // 导出证明
      exportVehicleCertModal: false,
      exportVehicleCertId: null,
      exportVehicleCertInstalled: false,

      // 车辆识别码
      vehicleIdentificationcodeModal: false,
      vehicleIdentificationcodeId: null,
      vehicleIdentificationcodeInstalled: false,

      // 订单基本信息
      installOrderBaseDetailModal: false,
      installOrderBaseDetailId: null,

      // 车辆信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 临时车辆资料图片管理
      tempVehiclePictureModal: false,
      tempVehiclePictureId: null,

      // 图片管理
      vehiclePictureModal: false,
      vehiclePictureId: null,

      // 车辆安装图片管理
      installOrderPictureModal: false,
      installOrderPictureModalId: null,

      // 确认收款
      confirmReceptModal: false,
      confirmReceptId: null,

      // 确认安装
      confirmInstalledModal: false,
      confirmInstalledId: null,

      // 指派安装员
      changeInstallerModal: false,
      changeInstallerId: null,

      // 安装订单配置设备
      bindPositioningDevicesModal: false,
      bindPositioningDevicesId: null,

      // 安装订单配置定位设备配件
      bindPositioningDevicesFittingsModal: false,
      bindPositioningDevicesFittingsId: null,

      // 安装订单详细信息
      installOrderDetailModal: false,
      installOrderDetailId: null,

      // 保险承诺函
      reqParams: {
        setInsuranceVideoCommitment: false,
        installDatetime: null,
        registrationNum: null,
        id: null,
        isall: false,
        manufacturer: 1
      },

      manufacturerpubTypeOptions: [
        { name: '深圳市锐明技术股份有限公司', value: 1 },
        { name: '江苏市中天安驰科技有限公司', value: 2 }
      ],

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        installOrderId: null
      },

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      columnsDisplay: [],
      columnHeaders: [],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '订单号',
          resizable: true,
          key: 'orderNum',
          sortable: 'custom',
          width: 180
        },
        {
          title: '车辆信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          render: (h, params) => {
            let registrationNum = ''
            let identificationCode = ''
            let vin = ''
            if (params.row.vehicleInfo) {
              registrationNum = params.row.vehicleInfo.registrationNum === null ? '无' : params.row.vehicleInfo.registrationNum
              identificationCode = params.row.vehicleInfo.identificationCode === null ? '无' : params.row.vehicleInfo.identificationCode
              vin = params.row.vehicleInfo.vin === null ? '无' : params.row.vehicleInfo.vin
            } else {
              registrationNum = params.row.tempVehicleInfo.registrationNum === null ? '无' : params.row.tempVehicleInfo.registrationNum
              identificationCode = params.row.tempVehicleInfo.identificationCode === null ? '无' : params.row.tempVehicleInfo.identificationCode
              vin = params.row.tempVehicleInfo.vin === null ? '无' : params.row.tempVehicleInfo.vin
            }
            return h('div', [
              h('div', '车牌:' + registrationNum + '(识别码:' + identificationCode + ')'),
              h('div', '车架号:' + vin)
            ])
          }
        },
        {
          title: '公司资料',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            if (params.row.vehicleInfoGroup) {
              return h('div', '公司名称:' + params.row.vehicleInfoGroup.name)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '加急订单',
          resizable: true,
          key: 'urgent',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          render: (h, params) => {
            const urgent = params.row.urgent
            if (urgent != null) {
              if (urgent) {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'error'
                    }
                  }, '加急')
                ])
              } else {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'blue'
                    }
                  }, '普通')
                ])
              }
            }
          }
        },
        {
          title: '订单状态',
          resizable: true,
          key: 'state',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '指派', value: 1 },
            { label: '完成', value: 2 },
            { label: '作废', value: 0 },
            { label: '异常', value: -1 },
            { label: '审核', value: 3 },
            { label: '配货', value: 4 },
            { label: '安装', value: 5 },
            { label: '回访', value: 6 },
            { label: '收款', value: 7 }
          ],
          filterMultiple: true,
          filteredValue: [1, 2, 3, 4, 5, 6, 7],
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.state
            let step = null
            if (state != 0) {
              if (params.row.step != null) {
                step = params.row.step.state
              } else {
                step = 1
              }
              if (params.row.setupDatetime != null) {
                state = 5
              }
              if (state === 1) {
                if (params.row.installer != null) {
                  step = 2
                }
                if (step === 0) {
                  return h('div', '作废')
                } else if (step === 1) {
                  return h('div', '待指派')
                } else if (step === 2) {
                  return h('div', '已指派')
                } else if (step === 3) {
                  return h('div', '指派失败')
                }
              } else if (state === 2) {
                return h('div', '完成')
              } else if (state === 0) {
                return h('div', '作废')
              } else if (state === -1) {
                return h('div', '异常')
              } else if (state === 3) {
                if (step === 0) {
                  return h('div', '作废')
                } else if (step === 1) {
                  return h('div', '审核中')
                } else if (step === 2) {
                  return h('div', '审核通过')
                } else if (step === 3) {
                  return h('div', '审核不通过')
                }
              } else if (state === 4) {
                if (step === 0) {
                  return h('div', '作废')
                } else if (step === 1) {
                  return h('div', '待配货')
                } else if (step === 2) {
                  return h('div', '已配货')
                } else if (step === 3) {
                  return h('div', '配货失败')
                }
              } else if (state === 5) {
                if (step === 0) {
                  return h('div', '作废')
                } else if (step === 1) {
                  return h('div', '待安装')
                } else if (step === 2) {
                  return h('div', '已安装')
                } else if (step === 3) {
                  return h('div', '安装失败')
                }
              } else if (state === 6) {
                if (step === 0) {
                  return h('div', '作废')
                } else if (step === 1) {
                  return h('div', '待回访')
                } else if (step === 2) {
                  return h('div', '已回访')
                } else if (step === 3) {
                  return h('div', '回访失败')
                }
              } else if (state === 7) {
                if (step === 0) {
                  return h('div', '作废')
                } else if (step === 1) {
                  return h('div', '待收款')
                } else if (step === 2) {
                  return h('div', '已收款')
                } else if (step === 3) {
                  return h('div', '收款失败')
                }
              }
            }
          }
        },
        {
          title: '结果',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.step != null) {
              if (params.row.step.result) {
                return h('div', {
                  style: {
                    color: 'red'
                  }
                }, params.row.step.result)
              } else {
                return h('div', {
                  style: {
                    color: 'green'
                  }
                }, '无')
              }
            }
          }
        },
        {
          title: '超时',
          resizable: true,
          key: 'timeoutLogo',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '未超时', value: 0 },
            { label: '已超时', value: 1 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.timeoutLogoFilter = []
              val.forEach(item => {
                if (item == 1) {
                  this.timeoutLogoFilter.push(genQueryParam('timeoutLogo', 'EQBOOL', true))
                } else {
                  this.timeoutLogoFilter.push(genQueryParam('timeoutLogo', 'EQBOOL', false))
                }
              })
            } else {
              this.timeoutLogoFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.timeoutLogo) {
              return h('div', '已超时')
            } else {
              return h('div', '未超时')
            }
          }
        },
        {
          title: '预约信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 240,
          render: (h, params) => {
            let bookingDatetime
            let bookingPlace
            let actualDatetime
            let actualPlace
            if (params.row.actualDatetime) {
              if (params.row.actualDatetime) {
                actualDatetime = new Date(params.row.actualDatetime).Format('yyyy年MM月dd日 hh:mm')
              } else {
                actualDatetime = '无'
              }
              if (params.row.actualPlace) {
                actualPlace = params.row.actualPlace
              } else {
                actualPlace = '无'
              }
              return h('div', [
                h('div', '重新预约时间:' + actualDatetime),
                h('div', '重新预约地点:' + actualPlace)
              ])
            } else {
              if (params.row.bookingDatetime) {
                bookingDatetime = new Date(params.row.bookingDatetime).Format('yyyy年MM月dd日 hh:mm')
              } else {
                bookingDatetime = '无'
              }
              if (params.row.bookingPlace) {
                bookingPlace = params.row.bookingPlace
              } else {
                bookingPlace = '无'
              }
              return h('div', [
                h('div', '预约时间:' + bookingDatetime),
                h('div', '预约地点:' + bookingPlace)
              ])
            }
          }
        },
        {
          title: '安装员',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 100,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.installerFilter = []
              val.forEach(item => {
                if (item == null) {
                  this.installerFilter.push(genQueryParam('installerId', 'EQNULL'))
                } else {
                  this.installerFilter.push(genQueryParam('installerId', 'EQ', item))
                }
              })
            } else {
              this.installerFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            if (params.row.installer) {
              let name = null
              if (params.row.installer.realName != null) {
                name = params.row.installer.realName
              } else if (params.row.installer.nickName != null) {
                name = params.row.installer.nickName
              } else if (params.row.installer.name != null) {
                name = params.row.installer.name
              }
              return h('div', name)
            } else {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '未分配')
            }
          }
        },
        {
          title: '协助安装人员',
          resizable: true,
          key: 'installers',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          render: (h, params) => {
            if (params.row.installers) {
              let name = params.row.installers
              // if (params.row.installer.realName) {
              //   name = params.row.installer.realName
              // } else if (params.row.installer.nickName) {
              //   name = params.row.installer.nickName
              // } else if (params.row.installer.name) {
              //   name = params.row.installer.name
              // }
              return h('div', name)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '跟进业务员',
          resizable: true,
          key: 'businessUserId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.businessUserFilter = []
              val.forEach(item => {
                this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
              })
            } else {
              this.businessUserFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.businessUser) {
              let name = null
              if (params.row.businessUser.realName) {
                name = params.row.businessUser.realName
              } else if (params.row.businessUser.nickName) {
                name = params.row.businessUser.nickName
              } else if (params.row.businessUser.name) {
                name = params.row.businessUser.name
              }
              return h('div', name)
            }
          }
        },
        {
          title: '业务类型',
          resizable: true,
          key: 'businessType',
          ellipsis: 'true',
          tooltip: 'true',
          width: 100,
          render: function (h, params) {
            let businessType = params.row.businessType
            if (businessType === 1) {
              return h('div', '新装')
            } else if (businessType === 2) {
              return h('div', '接入')
            } else if (businessType === 3) {
              return h('div', '在网升级')
            }
          }
        },
        {
          title: '设备详细',
          resizable: true,
          key: 'businessType',
          ellipsis: 'true',
          tooltip: 'true',
          width: 220,
          render: function (h, params) {
            let positioningDevice = null
            let positioningDeviceinfo = null
            if (params.row.positioningDevice != null) {
              positioningDevice = params.row.positioningDevice
            }
            let PositioningDeviceFittingsModel = null
            let newPositioningDeviceinfo = null
            if (params.row.newPositioningDeviceFittingsModel != null) {
              PositioningDeviceFittingsModel = params.row.newPositioningDeviceFittingsModel
            }
            if (positioningDevice) {
              positioningDeviceinfo = positioningDevice.positioningDeviceModel.name + '(' + new Date(positioningDevice.serviceDatetime).Format('yyyy年MM月dd日') + ')'
            }
            if (PositioningDeviceFittingsModel) {
              newPositioningDeviceinfo = PositioningDeviceFittingsModel.positioningDeviceModel.name + '(' + new Date(params.row.serviceDatetime).Format('yyyy年MM月dd日') + ')'
            }
            if (positioningDevice != null && PositioningDeviceFittingsModel != null) {
              return h('div', [
                h('div', '原设备:' + positioningDeviceinfo),
                h('div', '升级设备:' + newPositioningDeviceinfo)
              ])
            } else {
              let positioningDeviceInfos = null
              let positioningDeviceInfo = null
              if (params.row.positioningDeviceInfos) {
                positioningDeviceInfos = params.row.positioningDeviceInfos
                positioningDeviceInfo = positioningDeviceInfos[0].positioningDeviceModel.name + '(' + new Date(positioningDeviceInfos[0].serviceDatetime).Format('yyyy年MM月dd日') + ')'
              }
              if (positioningDeviceInfo) {
                return h('div', [
                  h('div', '设备:' + positioningDeviceInfo)
                ])
              } else {
                return h('div', [
                  h('div', '无')
                ])
              }
            }
          }
        },
        {
          title: '摄像头通道',
          resizable: true,
          key: 'businessType',
          ellipsis: 'true',
          tooltip: 'true',
          width: 220,
          render: function (h, params) {
            let positioningDeviceInfos = null
            if (params.row.positioningDeviceInfos) {
              positioningDeviceInfos = params.row.positioningDeviceInfos
            }
            var str = ''
            if (positioningDeviceInfos != null && positioningDeviceInfos.length > 0) {
              if (positioningDeviceInfos[0].aisleOne != null && positioningDeviceInfos[0].aisleOne) {
                str += '1-'
              }
              if (positioningDeviceInfos[0].aisleTwo != null && positioningDeviceInfos[0].aisleTwo) {
                str += '2-'
              }
              if (positioningDeviceInfos[0].aisleThree != null && positioningDeviceInfos[0].aisleThree) {
                str += '3-'
              }
              if (positioningDeviceInfos[0].aisleFour != null && positioningDeviceInfos[0].aisleFour) {
                str += '4-'
              }
              if (positioningDeviceInfos[0].aisleFive != null && positioningDeviceInfos[0].aisleFive) {
                str += '5-'
              }
              if (positioningDeviceInfos[0].aisleSix != null && positioningDeviceInfos[0].aisleSix) {
                str += '6-'
              }
              if (positioningDeviceInfos[0].aisleSeven != null && positioningDeviceInfos[0].aisleSeven) {
                str += '7-'
              }
              if (positioningDeviceInfos[0].aisleEight != null && positioningDeviceInfos[0].aisleEight) {
                str += '8-'
              }
              if (positioningDeviceInfos[0].aisleNine != null && positioningDeviceInfos[0].aisleNine) {
                str += '9-'
              }
              if (positioningDeviceInfos[0].aisleTen != null && positioningDeviceInfos[0].aisleTen) {
                str += '10-'
              }
            }
            str = str.substring(0, str.length - 1)
            // console.log(str)
            if (positioningDeviceInfos != null && positioningDeviceInfos[0].positioningDeviceModel.adas) {
              return h('div', [
                h('div', '通道:' + str)
              ])
            } else {
              return h('div', [
                h('div', '无')
              ])
            }
          }
        },
        {
          title: '配件列表',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          key: 'newPositioningDeviceFittingsModel',
          width: 260,
          render: function (h, params) {
            let str1 = ''
            let str2 = ''
            let PositioningDeviceFittings = params.row.newPositioningDeviceFittingsModel
            if (PositioningDeviceFittings) {
              if (PositioningDeviceFittings.starLightAlarm) {
                if (PositioningDeviceFittings.starLightAlarmType) {
                  str1 += PositioningDeviceFittings.starLightAlarmType.name + ','
                }
              }
              if (PositioningDeviceFittings.viewingScreen) {
                if (PositioningDeviceFittings.viewingScreenType) {
                  str1 += PositioningDeviceFittings.viewingScreenType.name + ','
                }
              }
              if (PositioningDeviceFittings.interphone) {
                if (PositioningDeviceFittings.interphoneType) {
                  str1 += PositioningDeviceFittings.interphoneType.name + ','
                }
              }
              if (PositioningDeviceFittings.trumpet) {
                if (PositioningDeviceFittings.trumpetType) {
                  str1 += PositioningDeviceFittings.trumpetType.name + ','
                }
              }
              if (PositioningDeviceFittings.hardDisk) {
                if (PositioningDeviceFittings.hardDiskType) {
                  str1 += PositioningDeviceFittings.hardDiskType.name + ','
                }
              }
              if (PositioningDeviceFittings.extensionCord) {
                if (PositioningDeviceFittings.extensionCordOneType) {
                  str1 += PositioningDeviceFittings.extensionCordOneType.name
                  str1 += '*' + PositioningDeviceFittings.extensionCordOneNum + ','
                }
                if (PositioningDeviceFittings.extensionCordFiveType) {
                  str1 += PositioningDeviceFittings.extensionCordFiveType.name
                  str1 += '*' + PositioningDeviceFittings.extensionCordFiveNum + ','
                }
                if (PositioningDeviceFittings.extensionCordFifteenType) {
                  str1 += PositioningDeviceFittings.extensionCordFifteenType.name
                  str1 += '*' + PositioningDeviceFittings.extensionCordFifteenNum + ','
                }
              }

              if (PositioningDeviceFittings.camera) {
                if (PositioningDeviceFittings.cameraOneType) {
                  str2 += PositioningDeviceFittings.cameraOneType.name
                  str2 += '*' + PositioningDeviceFittings.cameraOneNum + ','
                }
                if (PositioningDeviceFittings.cameraTwoType) {
                  str2 += PositioningDeviceFittings.cameraTwoType.name
                  str2 += '*' + PositioningDeviceFittings.cameraTwoNum + ','
                }
                if (PositioningDeviceFittings.cameraThreeType) {
                  str2 += PositioningDeviceFittings.cameraThreeType.name
                  str2 += '*' + PositioningDeviceFittings.cameraThreeNum + ','
                }
                if (PositioningDeviceFittings.cameraFourType) {
                  str2 += PositioningDeviceFittings.cameraFourType.name
                  str2 += '*' + PositioningDeviceFittings.cameraFourNum + ','
                }
                if (PositioningDeviceFittings.cameraFiveType) {
                  str2 += PositioningDeviceFittings.cameraFiveType.name
                  str2 += '*' + PositioningDeviceFittings.cameraFiveNum + ','
                }
              }
            }
            return h('div', [
              h('div', str1),
              h('div', str2)
            ])
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 320,
          fixed: 'right',
          render: (h, params) => {
            let display = []

                display.push(
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.installOrderBaseDetailId = params.row.id
                        this.installOrderBaseDetailModal = true
                      }
                    }
                  }, '设备')
                )
                display.push(
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.vehicleInfoDetailId = params.row.vehicleInfoId
                        this.vehicleInfoDetailModal = true
                      }
                    }
                  }, '安装图片')
                )
                display.push(
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.installOrderDetailId = params.row.id
                        this.installOrderDetailModal = true
                      }
                    }
                  }, '确认安装')
                )
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.installOrderBaseDetailId = params.row.id
                      this.installOrderBaseDetailModal = true
                    }
                  }
                }, '指派安装员')
              )

            return display
          }
        }
      ]// cloumn

    }// return
  }, // data
  methods: {
    ...mapActions([
      'InstallOrderServ_GetPage'
    ]),
    rowClassName (row, index) {
      // if (row.bookingDatetime) {
      //   if (row.state == 1 || row.state == 2) {
      //     if (row.bookingDatetime + 86400000 < new Date().getTime()) {
      //       // console.log(row)
      //       // console.log(index)
      //       return 'demo-table-error-row'
      //     }
      //   }
      // }
      if (row.setupDatetime == null) {
        if (row.state != 2) {
          if (row.timeoutLogo) {
            return 'demo-table-error-row'
          } else {
            return ''
          }
        }
      }
    },
    /**
     * 批量选择功能
     */
    onselectionchange (selection) {
      console.log(selection)
      this.installOrderList = []
      selection.forEach(item => {
        this.installOrderList.push(item.id)
      })
      console.log(this.installOrderList)
    },
    onselect (selection, row) {
      console.log(selection)
      this.installOrderList = []
      selection.forEach(item => {
        this.installOrderList.push(item.id)
      })
      console.log(this.installOrderList)
    },
    onselectcancel (selection, row) {
      console.log(selection)
      this.installOrderList = []
      selection.forEach(item => {
        this.installOrderList.push(item.id)
      })
      console.log(this.installOrderList)
    },
    onselectall (selection) {
      console.log(selection)
      this.installOrderList = []
      selection.forEach(item => {
        this.installOrderList.push(item.id)
      })
      console.log(this.installOrderList)
    },
    onselectallcancel (selection) {
      console.log(selection)
      this.installOrderList = []
      selection.forEach(item => {
        this.installOrderList.push(item.id)
      })
      console.log(this.installOrderList)
    },
    onOkInsuranceVideoCommitment () {
      if (this.reqParams.installDatetime != null || this.reqParams.installDatetime != '') {
        this.reqParams.installDatetime = new Date(this.reqParams.installDatetime).getTime()
      } else {
        this.reqParams.installDatetime = null
      }
      axios.request({
        method: 'POST',
        url: '/om/installorder/generateinsurancevideocommitment',
        data: this.reqParams,
        responseType: 'blob'
      }).then(res => {
        let blob = res.data
        let reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = (e) => {
          let a = document.createElement('a')

          let name = ''
          if (this.reqParams.registrationNum) {
            name = '保险承诺函：' + this.reqParams.registrationNum
          } else {
            name = '保险承诺函'
          }

          a.download = name + '.doc'
          a.href = e.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      }).catch((error) => {

      })
    },
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onUploadSuccess (response, file, fileList) {
      // console.log(response)
      // console.log(file)
      // console.log(fileList)
      this.$Message.success({
        content: response.msg,
        duration: 0,
        closable: true
      });
      // this.setPage(this.pageIndex)
    },
    downloadTemple (e) {
      console.log(e)
      window.location.href = e
    },
    onExportExcel () {
      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('createDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      } else {
        qo1 = [
          genQueryParam('state', 'EQ', 0),
          genQueryParam('state', 'EQ', 1),
          genQueryParam('state', 'EQ', 2),
          genQueryParam('state', 'EQ', 3),
          genQueryParam('state', 'EQ', 4),
          genQueryParam('state', 'EQ', 5),
          genQueryParam('state', 'EQ', 6),
          genQueryParam('state', 'EQ', 7)
        ]
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.businessUserFilter) {
        qo2 = this.businessUserFilter
      }
      if (this.billTypeFilter) {
        qo3 = this.billTypeFilter
      }
      if (this.isfreeFilter) {
        qo4 = this.isfreeFilter
      } else {
        qo4 = genQueryParam('isfree', 'EQ', 1)
      }
      if (this.selectCreateDatetime[0] && this.selectCreateDatetime[1]) {
        let startDatetime = new Date(this.selectCreateDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectCreateDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        if (this.FilterClickFilter != null) {
          queryParams.push(genQueryParam(this.FilterClickFilter, 'BTDT', startDatetime, endDatetime))
        } else {
          queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
        }
      }
      let urlparams = {
        qo1: qo1,
        qo2: qo2,
        qo3: qo3,
        qo4: qo4,
        q: queryParams,
        keyword: this.keywordFilter
      }
      window.location.href = '/api/om/installorder/getteamoperatorreport' + genURLParams(urlparams)
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '安装员') {
          this.columns[i].filters = this.installers
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '销售渠道') {
          this.columns[i].filters = this.allSalesChannels
          break
        }
      }
    },
    onFilterClick () {
      this.FilterClickFilter = null
      this.setPage(1)
    },
    DropdownonFilterClick (name) {
      this.FilterClickFilter = name
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)

      this.pageIndex = page
      this.listLoadding = true

      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let qo5 = null
      let qo6 = null
      let qo7 = null
      let qo8 = null
      let qo9 = null
      let qo10 = null
      let qo11 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('createDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      } else {
        qo1 = [genQueryParam('state', 'EQ', 1),
          genQueryParam('state', 'EQ', 2),
          genQueryParam('state', 'EQ', 3),
          genQueryParam('state', 'EQ', 4),
          genQueryParam('state', 'EQ', 5),
          genQueryParam('state', 'EQ', 6),
          genQueryParam('state', 'EQ', 7)]
      }
      if (this.installedFilter) {
        queryParams.push(this.installedFilter)
      }
      if (this.qghyptOptionFilter) {
        qo2 = this.qghyptOptionFilter
      }
      if (this.uploadStateFilter) {
        qo3 = this.uploadStateFilter
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.installerFilter) {
        qo4 = this.installerFilter
      }
      if (this.businessUserFilter) {
        qo5 = this.businessUserFilter
      }
      if (this.billTypeFilter) {
        qo6 = this.billTypeFilter
      }
      if (this.gdcdgovVehicleStateFilter) {
        qo7 = this.gdcdgovVehicleStateFilter
      }
      if (this.salesChannelFilter) {
        qo8 = this.salesChannelFilter
      }
      if (this.businessTypeFilter) {
        qo9 = this.businessTypeFilter
      }
      if (this.isfreeTypeFilter) {
        qo10 = this.isfreeTypeFilter
      }
      if (this.timeoutLogoFilter) {
        qo11 = this.timeoutLogoFilter
      }
      if (this.selectCreateDatetime[0] && this.selectCreateDatetime[1]) {
        let startDatetime = new Date(this.selectCreateDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectCreateDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        if (this.FilterClickFilter != null) {
          queryParams.push(genQueryParam(this.FilterClickFilter, 'BTDT', startDatetime, endDatetime))
        } else {
          queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
        }
      }

      store.dispatch('InstallOrderServ_GetMyUserGroupPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          qo5: qo5,
          qo6: qo6,
          qo7: qo7,
          qo8: qo8,
          qo9: qo9,
          qo10: qo10,
          qo11: qo11,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
  },
  computed: {
    computeCol () {
      let columns = this.columns
      columns = columns.filter(col => {
        for (var i = 0; i < this.columnsDisplay.length; i++) {
          if (this.columnsDisplay[i] === col.title) {
            return true
          }
        }
        return false
      })
      return columns
    },
    totalElements () {
      if (store.getters.get_InstallOrder_GetMyUserGroupPageResult) {
        return store.getters.get_InstallOrder_GetMyUserGroupPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_InstallOrder_GetMyUserGroupPageResult) {
        return store.getters.get_InstallOrder_GetMyUserGroupPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_InstallOrder_GetMyUserGroupPageResult) {
        return store.getters.get_InstallOrder_GetMyUserGroupPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

      this.columns.forEach(item => {
        this.columnHeaders.push(item.title)
        this.columnsDisplay.push(item.title)
      })
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8, 14] }
      }).then(() => {
        let installers = store.getters.get_User_GetAllUsersResult
        installers.forEach(item => {
          if (item.state === 1){
            // console.log(item.id)
            // console.log(item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name)
            this.installers.push({ label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id })
          }
        })
        // this.installers = installers.map(item => {
        //   return { label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id }
        // })
        this.installers.push({ label: '未分配', value: null })
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          let marketsales = store.getters.get_User_GetAllUsersResult
          marketsales.forEach(item => {
            if (item.state === 1){
              // console.log(item.id)
              // console.log(item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name)
              this.marketsales.push({ label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id })
            }
          })
          // this.marketsales = marketsales.map(item => {
          //   return { label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id }
          // })

          store.dispatch('SalesChannelServ_GetAll', {
            params: null,
            urlparams: null
          }).then(() => {
            let allSalesChannels = store.getters.get_SalesChannel_GetAllResult
            this.allSalesChannels = allSalesChannels.map(item => {
              return { label: item.name, value: item.id }
            })
            this.onColumnUpdate()
          }).catch(err => {
            this.$Message.error(err)
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
